import { getEnvSettings } from "../resources/getEnvSettings";
import { EnvSettingsData } from "../types";

declare global {
  // eslint-disable-next-line no-var
  var ENV_SETTINGS: EnvSettingsData;
}

/** Loads `env-settings.json` and makes the data available globally via the `ENV_SETTINGS` variable. */
export function loadEnvSettings() {
  try {
    globalThis.ENV_SETTINGS = getEnvSettings();
  } catch (error) {
    console.error("loadEnvSettings: ", error);
  }
}
